module.exports = __webpack_public_path__ + "img/logo_leelee_solo.5126290d.png";